module.exports = __webpack_public_path__ + "img/story026@2x.455b867d.webp";